import {  Routes, Route, Navigate } from 'react-router-dom';
import { Home, Login, Signup, Forgotpassword, Resetpassword, Aboutus, Dashboard, Howitworks, Faqs, Terms, PrivacyPolicy, Notification, ContactUs, Technician, Existing, SuperFan, ServiceDetail, MyBookings, BookAppointment, RatingReview, TipOfMonth, Profile, ChangePassword, ApplyForFinancing, Rating,ServiceProviderContactUs, ServiceProviderDetails, Payment, SelectPayment, PaynowSelectPayment, SearchServiceProvider, ServiceTrack, RequestViewDetails , ServiceProviderList, ServiceProviderMap, AffiliateLogin, Paynow, AffiliateForgotpassword, AffiliateResetpassword, PaynowPayment, ServiceProviderDetailsMiles, TechnicianFaqs, StoreProfile, PromoCode, QaNca, QaNcaServiceProviderList, QaNcaServiceProviderMap, QaNcaServiceProviderDetailsMiles, QaNcaBookAppointment, RequestViewDetailsNew, RequestViewDetailsOld,Payonline, WebsiteUnderMaintenance} from '../pages';
import MembershipPayment from '../pages/Membershippayment';

function RouteList() {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<Forgotpassword />} />
            <Route path="/reset-password" element={<Resetpassword />} /> 
            <Route path="/aboutus" element={<Aboutus />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/howitworks" element={<Howitworks />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/terms-conditions" element={<Terms />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/service-detail" element={<ServiceDetail />} />
            <Route path="/my-bookings" element={<MyBookings />} /> 
            <Route path="/book-appointment" element={<BookAppointment />} /> 
            <Route path="/rating-review" element={<RatingReview />} />
            <Route path="/tip-of-the-month" element={<TipOfMonth />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/apply-for-financing" element={<ApplyForFinancing />} />
            <Route path="/service-provider-details" element={<ServiceProviderDetails />} />
            <Route path="/service-provider-contact-us" element={<ServiceProviderContactUs />} />
            <Route path="/rating" element={<Rating />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/select-payment" element={<SelectPayment />} />
            <Route path="/paynow-select-payment" element={<PaynowSelectPayment />} />
            <Route path="/search-service-provider" element={<SearchServiceProvider />} />
            <Route path="/request-view-details" element={<RequestViewDetails />} />
            <Route path="/service-provider-list" element={<ServiceProviderList />} />
            <Route path="/service-provider-map" element={<ServiceProviderMap />} />
            <Route path="/technician" element={<Technician />} />
            <Route path="/affiliate-login" element={<AffiliateLogin />} />            
            <Route path="/existing-company" element={<Existing />} />
            <Route path="/become-a-super-fan" element={<SuperFan />} />
            <Route path="/service-track" element={<ServiceTrack />} />
            <Route path="/paynow" element={<Paynow />} />
            <Route path="/affiliate-forgot-password" element={<AffiliateForgotpassword />} />
            <Route path="/affiliate-reset-password" element={<AffiliateResetpassword />} />
            <Route path="/paynow-payment" element={<PaynowPayment />} />
            <Route path="/service-provider-details-miles" element={<ServiceProviderDetailsMiles/>} />
            <Route path="/technician-faqs" element={<TechnicianFaqs/>} />
            <Route path="/store-profile" element={<StoreProfile/>} />
            <Route path="/promo-code" element={<PromoCode/>} />
            <Route path="/qanca" element={<QaNca/>} />
            <Route path="/qanca-service-provider-list" element={<QaNcaServiceProviderList/>} />
            <Route path="/qanca-service-provider-map" element={<QaNcaServiceProviderMap/>} />
            <Route path="/qanca-service-provider-details-miles" element={<QaNcaServiceProviderDetailsMiles/>} />
            <Route path="/qanca-book-appointment" element={<QaNcaBookAppointment/>} />
            <Route path="/request-view-details-new" element={<RequestViewDetailsNew />} />
            <Route path="/request-view-details-old" element={<RequestViewDetailsOld />} />
            <Route path="/pay-online-guest" element={<Payonline />} />
            <Route path="/membership-payment" element={<MembershipPayment />} />
            <Route path="/maintenance" element={<WebsiteUnderMaintenance />} />
        </Routes>
    );
  }
  
  export default RouteList;